(function () {
  var MOBILE_MQ = window.matchMedia("(max-width: 900px)");
  var EXCLUSION_SELECTORS = [
    "#header",
    ".wt-header",
    ".wt-footer",
    ".wt-footer-page-section",
    "footer.wt-footer",
    ".shopify-section-group-footer-group",
    '[id^="shopify-section-"][class*="footer"]',
    ".wt-product__gallery",
    "gallery-section",
    ".main-product__buy-buttons--container",
    ".js-add-to-cart",
  ];
  var FOOTER_SELECTORS = [
    "footer.wt-footer",
    ".wt-footer",
    ".wt-footer-page-section",
    ".shopify-section-group-footer-group",
    '[id^="shopify-section-"][class*="footer"]',
  ];
  var PAD = 16;
  var FOOTER_PAD = 24;
  var TAP_THRESHOLD = 8;
  var RESIZE_DEBOUNCE_MS = 100;
  var STORAGE_PREFIX = "am-surprise-dismissed:";

  function storageKey() {
    return STORAGE_PREFIX + window.location.pathname;
  }

  function isDismissed() {
    try {
      return sessionStorage.getItem(storageKey()) === "1";
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      sessionStorage.setItem(storageKey(), "1");
    } catch (e) {}
  }

  function getSize(configEl) {
    var mobile = MOBILE_MQ.matches;
    var raw = mobile
      ? configEl.dataset.sizeMobile
      : configEl.dataset.sizeDesktop;
    var size = parseInt(raw, 10);
    return !isNaN(size) && size > 0 ? size : mobile ? 72 : 96;
  }

  function toDocumentRect(rect) {
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
      right: rect.right + window.scrollX,
      bottom: rect.bottom + window.scrollY,
    };
  }

  function getExclusionRects() {
    var seen = new Set();
    var zones = [];

    EXCLUSION_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        var rect = el.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        zones.push(toDocumentRect(rect));
      });
    });

    return zones;
  }

  /** Document Y of the highest footer edge — surprises must stay fully above this. */
  function getFooterTopY() {
    var top = null;
    var seen = new Set();

    FOOTER_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        var rect = el.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        var docTop = rect.top + window.scrollY;
        if (top == null || docTop < top) top = docTop;
      });
    });

    return top;
  }

  function overlaps(rect, zones, padding) {
    var pad = padding == null ? PAD : padding;
    return zones.some(function (zone) {
      return (
        rect.left < zone.right + pad &&
        rect.right > zone.left - pad &&
        rect.top < zone.bottom + pad &&
        rect.bottom > zone.top - pad
      );
    });
  }

  function measureEl(el, size) {
    el.style.setProperty("--am-surprise-size", size + "px");
    var img = el.querySelector("img");
    var w = size;
    var h = img && img.offsetHeight > 0 ? img.offsetHeight : size;
    if (img && img.offsetWidth > 0) w = img.offsetWidth;
    return { width: w, height: h };
  }

  function documentScrollHeight() {
    return Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight,
    );
  }

  function viewportWidth() {
    return Math.min(
      window.innerWidth || Infinity,
      document.documentElement.clientWidth || Infinity,
    );
  }

  function getPositionBounds(w, h) {
    var docH = documentScrollHeight();
    var minY = window.innerHeight + PAD;
    var maxY = docH - h - PAD;

    // Hard cap: never place on/below the footer
    var footerTop = getFooterTopY();
    if (footerTop != null) {
      maxY = Math.min(maxY, footerTop - h - FOOTER_PAD);
    }

    return {
      minX: PAD,
      maxX: Math.max(PAD, viewportWidth() - w - PAD),
      minY: minY,
      maxY: Math.max(minY, maxY),
    };
  }

  function clampXY(x, y, w, h) {
    var bounds = getPositionBounds(w, h);
    return {
      x: Math.min(Math.max(bounds.minX, x), bounds.maxX),
      y: Math.min(Math.max(bounds.minY, y), bounds.maxY),
    };
  }

  function clampElementToViewport(el) {
    var rect = el.getBoundingClientRect();
    var w = rect.width;
    var h = rect.height;
    if (w < 1 || h < 1) return;

    var left = parseFloat(el.style.left) || 0;
    var top = parseFloat(el.style.top) || 0;
    var clamped = clampXY(left, top, w, h);

    // Keep document scrollWidth from exceeding the viewport after a narrow resize.
    var vw = viewportWidth();
    var maxLeft = Math.max(PAD, vw - w - PAD);
    if (clamped.x > maxLeft) clamped.x = maxLeft;
    if (clamped.x + w > vw - PAD) {
      clamped.x = Math.max(PAD, vw - w - PAD);
    }

    // If no safe vertical room above the footer, remove rather than land on it
    var bounds = getPositionBounds(w, h);
    if (bounds.maxY <= bounds.minY) {
      dismiss(el, false);
      return;
    }
    clamped.y = Math.min(clamped.y, bounds.maxY);

    el.style.left = clamped.x + "px";
    el.style.top = clamped.y + "px";
  }

  function bindResizeClamp(el) {
    var timer = null;

    function runClamp() {
      if (!document.body.contains(el)) return;
      clampElementToViewport(el);
    }

    function onResize() {
      runClamp();
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        runClamp();
      }, RESIZE_DEBOUNCE_MS);
    }

    window.addEventListener("resize", onResize, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", onResize, {
        passive: true,
      });
    }

    return function cleanup() {
      if (timer) clearTimeout(timer);
      window.removeEventListener("resize", onResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", onResize);
      }
    };
  }

  function teardownSurprise(el) {
    if (el && el._amSurpriseResizeCleanup) {
      el._amSurpriseResizeCleanup();
      el._amSurpriseResizeCleanup = null;
    }
  }

  function randomSafePosition(sizeW, sizeH, zones) {
    var bounds = getPositionBounds(sizeW, sizeH);
    if (bounds.maxY <= bounds.minY) return null;

    for (var attempt = 0; attempt < 60; attempt++) {
      var x =
        bounds.minX + Math.random() * Math.max(0, bounds.maxX - bounds.minX);
      var y =
        bounds.minY + Math.random() * Math.max(0, bounds.maxY - bounds.minY);
      var candidate = {
        left: x,
        top: y,
        right: x + sizeW,
        bottom: y + sizeH,
      };
      if (!overlaps(candidate, zones, PAD)) {
        return { x: x, y: y };
      }
    }

    return null;
  }

  function pickRandomUrl(urls) {
    if (!urls.length) return "";
    return urls[Math.floor(Math.random() * urls.length)];
  }

  function dismiss(el, remember) {
    if (remember !== false) markDismissed();
    teardownSurprise(el);
    el.remove();
    if (!document.querySelector(".am-floating-surprise")) {
      document.documentElement.classList.remove("am-floating-surprise-active");
      document.body.classList.remove("am-floating-surprise-active");
    }
  }

  function removeWithoutPlacing(el) {
    teardownSurprise(el);
    el.remove();
    if (!document.querySelector(".am-floating-surprise")) {
      document.documentElement.classList.remove("am-floating-surprise-active");
      document.body.classList.remove("am-floating-surprise-active");
    }
  }

  function bindInteractions(el, allowDrag) {
    var startX = 0;
    var startY = 0;
    var originLeft = 0;
    var originTop = 0;
    var dragging = false;
    var moved = false;
    var pointerId = null;

    function onPointerDown(e) {
      if (e.button !== 0 && e.pointerType === "mouse") return;
      dragging = allowDrag;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      originLeft = parseFloat(el.style.left) || 0;
      originTop = parseFloat(el.style.top) || 0;
      if (allowDrag) {
        el.classList.add("is-dragging");
        el.setPointerCapture(e.pointerId);
      }
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > TAP_THRESHOLD || Math.abs(dy) > TAP_THRESHOLD) {
        moved = true;
      }
      if (!moved || !allowDrag) return;

      var rect = el.getBoundingClientRect();
      var w = rect.width;
      var h = rect.height;
      var zones = getExclusionRects();
      var nextX = originLeft + dx;
      var nextY = originTop + dy;
      var clamped = clampXY(nextX, nextY, w, h);
      nextX = clamped.x;
      nextY = clamped.y;
      var candidate = {
        left: nextX,
        top: nextY,
        right: nextX + w,
        bottom: nextY + h,
      };

      if (!overlaps(candidate, zones, PAD)) {
        el.style.left = nextX + "px";
        el.style.top = nextY + "px";
      }
    }

    function onPointerUp(e) {
      if (e.pointerId !== pointerId) return;
      if (allowDrag) {
        el.classList.remove("is-dragging");
        try {
          el.releasePointerCapture(pointerId);
        } catch (err) {}
      }
      if (!moved) {
        dismiss(el);
      }
      dragging = false;
      pointerId = null;
    }

    el.addEventListener("pointerdown", onPointerDown);
    el.addEventListener("pointermove", onPointerMove);
    el.addEventListener("pointerup", onPointerUp);
    el.addEventListener("pointercancel", onPointerUp);
  }

  function init() {
    /* PDP mobile: never show floating surprise overlays. */
    if (
      MOBILE_MQ.matches &&
      document.body.classList.contains("template-product")
    ) {
      return;
    }

    var configEl = document.querySelector("[data-am-floating-surprise-config]");
    if (!configEl || isDismissed()) return;

    var jsonEl = configEl.querySelector('script[type="application/json"]');
    if (!jsonEl) return;

    var urls = [];
    try {
      urls = JSON.parse(jsonEl.textContent || "[]");
    } catch (e) {
      return;
    }
    urls = urls.filter(Boolean);
    if (!urls.length) return;

    var allowDrag = configEl.dataset.allowDrag === "true";
    var size = getSize(configEl);
    var src = pickRandomUrl(urls);

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "am-floating-surprise";
    btn.setAttribute("aria-label", "Dismiss decoration");
    btn.style.setProperty("--am-surprise-size", size + "px");

    var img = document.createElement("img");
    img.src = src;
    img.alt = "";
    img.draggable = false;
    img.loading = "lazy";
    img.width = size;
    btn.appendChild(img);

    document.documentElement.classList.add("am-floating-surprise-active");
    document.body.classList.add("am-floating-surprise-active");
    document.body.appendChild(btn);

    function place() {
      // Re-measure after layout so footer exclusions / top cap are accurate
      var zones = getExclusionRects();
      var dims = measureEl(btn, size);
      var pos = randomSafePosition(dims.width, dims.height, zones);
      if (!pos) {
        removeWithoutPlacing(btn);
        return;
      }
      btn.style.left = pos.x + "px";
      btn.style.top = pos.y + "px";
      clampElementToViewport(btn);
      if (!document.body.contains(btn)) return;
      btn._amSurpriseResizeCleanup = bindResizeClamp(btn);
      bindInteractions(btn, allowDrag);
      configEl.remove();
    }

    function placeWhenReady() {
      // Double rAF: wait for footer layout (incl. min-height: 100vh) before measuring
      requestAnimationFrame(function () {
        requestAnimationFrame(place);
      });
    }

    if (img.complete) {
      placeWhenReady();
    } else {
      img.addEventListener("load", placeWhenReady, { once: true });
      img.addEventListener(
        "error",
        function () {
          removeWithoutPlacing(btn);
        },
        { once: true },
      );
    }
  }

  function start() {
    if (document.readyState === "complete") {
      init();
    } else {
      window.addEventListener("load", init, { once: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
